export default __webpack_public_path__ + "static/media/gift2.cabdfff1.svg";